import React, { useState } from "react";
import { ICard } from "../../interfaces/card";
import { IFilter } from "../../interfaces/filter";
import { Card } from "../Card/Card";
import { Panel } from "../Panel/Panel";
import './style.css';

type MainProps = {
    addingToCartCallback: (value:HTMLInputElement)=>void
    loaded: boolean;
    cards: ICard[];
    filter: IFilter;
    filterCallback: (value: IFilter) => void;
};

export function Main(props: MainProps) {
    const [cardsStatus, setCardsStatus] = useState<Record<number,{checked: boolean}>>({});

    const setStatus = (cardCheck: {id: number, checked: boolean}) => {
        const newValue = cardsStatus;
        newValue[cardCheck.id] = {checked: cardCheck.checked};
        setCardsStatus(newValue);
    }

    return(
        <main className="main">
            <div className="main-wrapper">
                { props.loaded && <Panel cards = {props.cards}
                    filterCallback = {props.filterCallback}
                    filter = {props.filter}
                    loaded = {props.loaded}
                /> }
                { props.loaded && <div className={`cards-container ${props.loaded ? 'loaded' : ''}`}>
                    {props.cards
                        .map(card => {
                            card.checked = cardsStatus[card.id]?.checked || false;
                            return card
                        })
                        .filter(card => !card.hide)
                        .map(card => <Card
                            card = {card}
                            key = {card.id}
                            htmlFor = {`${card.id}`}
                            addingToCartCallback = {props.addingToCartCallback}
                            setStatusCardCallback = {setStatus}
                        />)}
                </div> }
                { props.loaded && props.cards.every(card => card.hide) &&
                    <h1 className="message-no-items">No products for the set filter options</h1>}
            </div>
        </main>
    )
}
